import React from 'react';
import { CHAPTER_STATUS } from '@squirrellearningltd/go-shared-utils';
import { Link } from '@reach/router';
import styles from './PublishedBooks.module.scss'

import { BOOK_STATUS } from '@squirrellearningltd/go-shared-utils';
import cx from 'classnames';

import noCover from '../../../../images/no-cover.png';
import taskCover from '../../../../images/task.png';

import navigationIcon from '../../../../images/new-dashboard/navigation-icon.svg';


const PublishedBooks = ({ books, showFirstX, columns = 2, imgWidth = 160, imgHeight = 200 }) => {
    if (books.length === 0) {
        return <p>You've not published anything yet!</p>
    }

    return <>
        <div className={styles.publishedBooksWrapper}
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
            {books
                .slice(0, showFirstX)
                .map(book => {
                    return (
                        <PublishedBook
                            key={book.id}
                            book={book}
                            imgWidth={imgWidth}
                            imgHeight={imgHeight}
                        />
                    )
                })}
        </div>
    </>
}

const PublishedBook = ({ book, showReadButton = false, imgWidth = 160, imgHeight = 200 }) => {
    return (
        <Link key={`book-${book.id}`} to={`book/${book.id}`} className={styles.dashboardBookCard}>
            <img
                width={imgWidth}
                height={imgHeight}
                className={cx(styles.dashboardBookCardImg, { [styles.dashboardBookCardImgBook]: !book.classPack?.isWritingActivity })}
                src={book.bookTemplate?.coverUrl || (book.classPack?.isWritingActivity ? taskCover : noCover)}
                alt={book.title || book.bookTemplate?.name}
            />
        </Link>
    )
}

export default PublishedBooks;   